import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TabsProjectTaskDashboard from "./tabsDetails";
import { TableProjectTaskAccordions } from "./ProjectTaskAccordions/table";
import { TableProjectTaskList } from "./ProjectTaskList/table";
import { defaultTheme } from "../../../theme/theme";
import { useColors } from "../../../theme/hooks/useColors";
import GenericPromises from "../../../api/GenericPromises";
import { usePermissions } from "../../../hooks/usePermissions";
import { Menuitem } from "../../../interfaces/Security/menu";
import useSnackBar from "../../../components/Commons/SnackBar/useSnackBar";
import { Header } from "../../../components/Header";
import { AuthContext } from "../../../context/AuthContext";
import { useBase64 } from "../../../hooks/useBase64";
import { FieldType } from "../../../interfaces/Projects/Catalogs/fieldTypes";
import { useTaskStatesStore } from "../../../store/Projects/TaskStates/TaskStatesStore";
import { TaskStatesFilter } from "./components/DashboardFilter/taskStatesFilter";

export const ViewProjectTaskDashboard = () => {
  const [t] = useTranslation("global");
  const { GenericGetResource } = GenericPromises();
  const { GetResourceByUrl } = usePermissions();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [color, setColor] = useState<number[]>();
  const { HexToRGB } = useColors();
  const { user } = useContext(AuthContext);
  const [projectGroupId, setProjectGroupId] = useState<number>();
  const { utf8ToBase64 } = useBase64();
  const [comboFieldTypes, setComboFieldTypes] = useState<FieldType[]>([])
  const setTaskStates = useTaskStatesStore(store => store.setTaskStates)
  const [isLoadingDataTable, setIsLoadingDataTable] = useState(false);

  useEffect(() => {
    GetResourceByUrl(`/projecttaskdashboard`)
      .then((response1) => {
        setResourceScreen((prev) => response1);
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });

    GenericGetResource(`/taskstates`)
      .then(async (response) => {
        setTaskStates(response.data.data)
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });

    if (user?.group_id) {
      setProjectGroupId(user?.group_id)
    }
    setColor(HexToRGB(defaultTheme.palette.primary.main));

    GenericGetResource(
      `/fieldtypes?filter=${utf8ToBase64(
        `field_type_nameLIKEformula|field_type_nameLIKEDate`
      )}`
    )
      .then((response) => {
        setComboFieldTypes(response.data.data)
      })
      .catch((error) => {
        showSnackBar(error.message, "error");
      });
  }, [])


  return (
    <>
      {resourceScreen?.read && (
        <>
          <Header title={t("projecttaskdashboard.title")}
            child={
              <TaskStatesFilter
                setIsLoadingDataTable={setIsLoadingDataTable}
              />
            }
          />
          <div className="my-4" />
          <TabsProjectTaskDashboard
            assignedToMe={
              <TableProjectTaskList
                color={color}
                isEdit={!resourceScreen.update}
                projectGroupId={projectGroupId}
                resourceScreen={resourceScreen}
                comboFieldTypes={comboFieldTypes}
                isLoadingDataTable={isLoadingDataTable}
              />
            }
            planned={
              <TableProjectTaskAccordions
                color={color}
                isEdit={!resourceScreen.update}
                resourceScreen={resourceScreen}
                comboFieldTypes={comboFieldTypes}
                isLoadingDataTable={isLoadingDataTable}
              />
            }
          />
        </>
      )}
      <SnackbarComponent />
    </>
  );
};
